'use client';

import React from 'react';
import { User, ShieldCheck, Calendar, Phone } from 'lucide-react';
import type { ProfileTab } from '../page';
import Icon from '@/components/ui/AppIcon';


interface ProfileHeaderProps {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
}

const tabs: { id: ProfileTab; label: string; icon: React.ElementType }[] = [
  { id: 'personal', label: 'Personal Info', icon: User },
  { id: 'credentials', label: 'Credentials', icon: ShieldCheck },
  { id: 'availability', label: 'Availability', icon: Calendar },
  { id: 'contact', label: 'Contact Details', icon: Phone },
];

export default function ProfileHeader({ activeTab, onTabChange }: ProfileHeaderProps) {
  return (
    <div className="space-y-5">
      {/* Profile banner */}
      <div className="bg-card border border-border rounded-xl p-5 flex items-center gap-5">
        <div className="relative flex-shrink-0">
          <div className="w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xl font-700">
            MR
          </div>
          <span className="absolute bottom-0 right-0 w-4 h-4 rounded-full bg-success border-2 border-card" />
        </div>
        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-700 text-foreground">Maria Rodriguez</h1>
          <p className="text-sm text-muted-foreground">Registered Nurse · ICU Department</p>
          <div className="flex items-center gap-3 mt-1.5 flex-wrap">
            <span className="inline-flex items-center gap-1 text-xs font-500 text-success bg-success/10 px-2 py-0.5 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-success" />
              Active
            </span>
            <span className="text-xs text-muted-foreground">Employee ID: EMP-0042</span>
            <span className="text-xs text-muted-foreground">Joined: Mar 2021</span>
          </div>
        </div>
        <div className="hidden sm:block text-right">
          <p className="text-xs text-muted-foreground">Last updated</p>
          <p className="text-sm font-500 text-foreground">Jul 28, 2024</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-muted p-1 rounded-lg w-fit flex-wrap">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-1.5 px-4 py-1.5 rounded-md text-sm font-500 transition-all ${
                activeTab === tab.id
                  ? 'bg-card text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon size={14} />
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
